module.exports = __webpack_public_path__ + "static/media/taxi.ae1aa2df.svg";